import React, { useState, useEffect, useRef, useCallback } from "react";
import { Col, Row, Divider, Button } from "antd";
import Webcam from "react-webcam";
import "./ScaleCamera.css";
import { ReloadOutlined } from "@ant-design/icons";

export interface ScaleCameraProps {
  webcamRef: any;
  imageSrc: any;
  deviceID: string;
  webcamName: string;
}

const ScaleCamera = (props: ScaleCameraProps) => {
  const windowNav: any = window.navigator;

  const reconnectButton = () => {
    if (windowNav.getUserMedia) {
      windowNav.getUserMedia(
        { audio: false, video: { width: 1280, height: 720 } },
        (stream: any) => {},
        (err: any) => {
          console.error(`The following error occurred: ${err.name}`);
        }
      );
      window.location.reload();
    } else {
      console.log("getUserMedia not supported");
    }
  };

  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);

  const handleDevices = React.useCallback((mediaDevices: any) => console.log(mediaDevices), [setDevices]);

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  return (
    <div className="webcam">
      <Col span={24}>
        <>
          <Webcam
            ref={props.webcamRef}
            mirrored={false}
            screenshotFormat="image/jpeg"
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
            }}
            minScreenshotHeight={800}
            minScreenshotWidth={800}
            videoConstraints={{ deviceId: props.deviceID }}
          />
          <h3
            style={{
              position: "absolute",
              top: "5px",
              left: "5px",
            }}
          >
            {props.webcamName} Camera
          </h3>
          <Button
            type="default"
            icon={<ReloadOutlined />}
            style={{
              position: "absolute",
              bottom: "5px",
              left: "5px",
            }}
            onClick={() => reconnectButton()}
          ></Button>
        </>
      </Col>
    </div>
  );
};

export default ScaleCamera;
